import React from 'react'
import { formatSalesValue } from '../../../../utils/formatUtils';

const KitchenSummaryDetails = ({ information }) => {
    const { DineIn, DineIn_totalSales, TakeAway_totalSales, TakeAway, Voids, Cooked, cooking } = information;

    const items = [
        { label: 'Dine In', value: DineIn },
        { label: 'Dine In Sales', value: DineIn_totalSales },
        { label: 'Takeaway', value: TakeAway },
        { label: 'Takeaway Sales', value: TakeAway_totalSales },
        { label: 'Voids', value: Voids === "" || Voids === null ? 0 : Voids },
        { label: 'Cooked', value: Cooked },
        { label: 'Cooking', value: cooking },
    ];

    return (
        <div className="flex flex-col gap-1.5">
            {items.map(({ label, value }) => (
                <div key={label} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
                    <span className="text-xs xl:text-sm text-gray-500 font-medium">{label}</span>
                    <span className="text-xs xl:text-sm font-semibold text-gray-800">
                        {formatSalesValue(value)}
                    </span>
                </div>
            ))}
        </div>
    )
}

export default KitchenSummaryDetails